import React, { useEffect } from "react";
import { FocusContext, useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import "./Terms.scss";

const CloseButton = ({ onEnterPress }) => {
    const { ref, focused } = useFocusable({
        focusKey: "TERMS_CLOSE",
        onEnterPress,
    });

    return (
        <div ref={ref}>
            <button className={`fullWidthBtn ${focused ? "focused" : ""}`} onClick={onEnterPress} tabIndex={-1} aria-label="Close">
                Close
            </button>
        </div>
    );
};

const TermsPopup = ({ event = {}, onClose, orgShouldCheckToSignTC }) => {
    const { ref, focusKey, focusSelf } = useFocusable({
        isFocusBoundary: true,
    });
    let message;
    if (orgShouldCheckToSignTC) {
        message = `To view this content, log in to the EverPass Manager via desktop, and agree to the latest Terms and Conditions`;
    }else if(event){
        const { subscriptionType } = event;
        message = `To continue viewing this content, log in to the EverPass Manager via desktop, click on ${subscriptionType.display_name} event and agree to the latest Terms and Conditions`;
    }

    useEffect(() => {
        focusSelf();
    }, [focusSelf]);

    return (
        <FocusContext.Provider value={focusKey}>
            <div className="backdrop" role="dialog" aria-modal="true">
                <div ref={ref} className="modalBox">
                    <h2 className="title">Terms & Conditions</h2>
                    <p className="message">{message}</p>
                    <CloseButton onEnterPress={onClose} />
                </div>
            </div>
        </FocusContext.Provider>
    );
};

export default TermsPopup;
